module.exports = __webpack_public_path__ + "img/selected3-min.ade583a7.png";